'use client'

import React from 'react'
import { cn, formatDateTime } from '@/lib/utils'

interface ClockProps extends React.ComponentPropsWithoutRef<'div'> {}

export const Clock = ({ className }: ClockProps) => {
  const [time, setTime] = React.useState(new Date())
  const clockWorkerRef = React.useRef<Worker>()

  const handleTime = React.useCallback((event: MessageEvent) => {
    setTime(event.data)
  }, [])

  React.useEffect(() => {
    clockWorkerRef.current = new Worker(
      new URL('@/lib/workers/clock.worker', import.meta.url),
    )

    clockWorkerRef.current.onerror = (error) => {
      console.error('Error:', error)
    }

    clockWorkerRef.current.onmessage = handleTime
    clockWorkerRef.current.postMessage('')

    return () => {
      clockWorkerRef?.current?.terminate()
    }
  }, [handleTime])

  return (
    <div
      suppressHydrationWarning
      className={cn('hidden md:inline-flex', className)}
    >
      {formatDateTime(time)}
    </div>
  )
}

Clock.displayName = 'Clock'
